import * as React from 'react';
import Logo from 'src/Assets/Images/GEHC-LOGO.png';
import './styles.scss';
import { useTranslation } from 'react-i18next';

const SetupHeader = (props) => {
  const { heading } = props;
  const { t } = useTranslation();
  return (
    <div className="account-header">
      <div className="logo-container">
        {props.activeKey === 'facilitySelection' ? (
          <span
            className="back-button"
            onClick={props.handleChangeFacilityClick}
          >
            {t('back')}
          </span>
        ) : (
          <>
            <img className="logo" src={Logo} alt="logo" />
            {/* <span className="logo-text">{t('GE')}</span> */}
          </>
        )}
      </div>
      <div className="page-heading">{heading}</div>
    </div>
  );
};

export default SetupHeader;
